import { render, staticRenderFns } from "./ShiftForm.vue?vue&type=template&id=1f16b896&scoped=true"
import script from "./ShiftForm.vue?vue&type=script&lang=js"
export * from "./ShiftForm.vue?vue&type=script&lang=js"
import style0 from "./ShiftForm.vue?vue&type=style&index=0&id=1f16b896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f16b896",
  null
  
)

export default component.exports